import { Dispatch, SetStateAction } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsContinue: Dispatch<SetStateAction<boolean>>;
};

const ModalCambiarObjetivo = ({ isOpen, setIsOpen, setIsContinue }: Props) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} >
      <DialogTitle>🔎 Atención sobre tu objetivo</DialogTitle>
      <DialogContent>
        Según el porcentaje de grasa que ingresaste (más de 25%), lo más recomendable sería iniciar con un proceso de pérdida de grasa, tal como explicamos en el video inicial. <br />
        👉 Si aun así estás 100% seguro de querer comenzar con el enfoque de ganancia de masa muscular, ¡vamos con todo!
        Pero si tu meta es transformar tu cuerpo de forma más eficiente, te sugerimos reconsiderar y seleccionar la opción de perder grasa como prioridad.
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <button
          className="bg-orangeTr4iner text-white px-4 py-2 rounded hover:bg-[#d17a0e]"
          onClick={() => setIsOpen(false)}
        >
          Regresar
        </button>
        <button
          className="bg-orangeTr4iner text-white px-4 py-2 rounded hover:bg-[#d17a0e]"
          onClick={() => { setIsContinue(true); setIsOpen(false)}}
        >
          Continuar
        </button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalCambiarObjetivo;
